import React from 'react';

import { useDateTimePicker } from 'components/hooks/useDatePicker';
import { StyledTooltip, StyledTypography } from 'styles/common';

import { convertDateToString11, convertDateToString7 } from 'constants/helper';

export const CheckInTime = ({
  startDateTime,
  endDateTime,
  onDateTimeChange,
  editable = true,
  isCompleted = false,
  className,
}) => {
  const openDateTimePicker = useDateTimePicker(onDateTimeChange);
  const onClickHandler = (e) => {
    if (editable) {
      e.stopPropagation();
      openDateTimePicker({
        initialDate: startDateTime,
        endDate: endDateTime,
        openTo: 'hours',
        isOneOnOneDatePicker: true,
      });
    }
  };
  return (
    <div className={className}>
      <StyledTooltip title={editable ? 'Reschedule' : ''}>
        <StyledTypography
          variant="body2"
          customColor="#7A96A8"
          cursor={editable ? 'pointer' : 'default'}
          onClick={onClickHandler}
          display="inline"
          strikeThrough={isCompleted}
        >
          {`${convertDateToString11(new Date(startDateTime))} at  ${convertDateToString7(
            new Date(startDateTime),
            true
          )}`}
        </StyledTypography>
      </StyledTooltip>
    </div>
  );
};
